<template>
  <div class="tag-list mrg-btm-20">
    <span class="tag" :class="{'active': categoryIds.includes(item.category.categoryId)}" v-for="(item) in list" :key="item.category.name" @click="select(item.category.categoryId)">{{item.category.name}}</span>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    },
    categoryIds: {
      type: Array,
      default () {
        return []
      }
    }
  },
  setup(props,{emit})  {
    const select = (val) => {
      let result = [...props.categoryIds]
      if (val !== 0) {
        if (result.includes(0)) {
          result.splice(result.indexOf(0, 1))
        }
        if (result.includes(val)) {
          result.splice(result.indexOf(val), 1)
        } else {
          result.push(val)
        }
        if (!result.length) {
          result.push(val)
        }
      } else {
        result = [0]
      }
      emit('update:categoryIds', result)
      setTimeout(() => {
        emit('toggleCategory', result)
      }, 10)
    }
    return {
      select
    }
  },
  methods: {
  },
  watch: {

  }
}
</script>

<style lang="scss" scoped>
.tag-list {
  .tag {
    display: inline-block;
    font-size: 12px;
    color: #222;
    line-height: 26px;
    font-weight: 400;
    background: #F3F4F5;
    border: 1px solid #F3F4F5;
    border-radius: 13px;
    padding: 0 12px;
    margin-right: 10px;
    cursor: pointer;
    min-width: 46px;
    text-align: center;
  }
  .active  {
    border-color: #F10180;
    color: #fff;
    background: #F10180;
  }
}
</style>
